<app-split-container>
  <div slot="left">
    <app-login-dialog-image
      [title]="'login.firstLogin.infoTitle' | translate"
      [subtitle]="'login.firstLogin.infoSubtitle' | translate"
    >
      <app-first-login-image></app-first-login-image>
    </app-login-dialog-image>
  </div>

  <div slot="right">
    <form (submit)="validateData($event)" [formGroup]="formGroup">

      <!-- Text -->
      <div *ngIf="message()" class="item-container">
        <p [innerHTML]="message()"></p>
      </div>

      <!-- Password change -->
      <div *ngIf="passwordControl" class="item-container password" [formGroup]="formGroup.get('password')">
        <opac-password-input
          formControlName="newPassword"
          name="new-password"
          [invalid]="passwordControl | invalidControl">
          {{ 'user.details.newPassword' | translate }}
          <span
            *ngIf="passwordControl | invalidControl"
            slot="error">
            {{ 'login.passwordFormat' | translate }}
          </span>
        </opac-password-input>

        <opac-password-input
          formControlName="confirmNewPassword"
          name="confirm-new-password"
          [invalid]="confirmPasswordControl | invalidControl">
          {{ 'user.fields.confirmPassword' | translate }}
          <span *ngIf="confirmPasswordControl | invalidControl" slot="error">
            {{ 'login.passwordNotMatching' | translate }}
          </span>
        </opac-password-input>
      </div>

      <!-- Email change -->
      <div *ngIf="emailControl" class="item-container">
        <opac-text-input formControlName="email" [invalid]="emailControl | invalidControl">
          {{ 'user.fields.email' | translate }}
          <span *ngIf="emailControl | invalidControl" slot="error">
            {{ 'user.account.invites.error.email' | translate }}
          </span>
        </opac-text-input>
      </div>

      <!-- RUT change -->
      <div *ngIf="rutControl" class="item-container">
        <p>{{ 'signup.e0314.register.invalidRutMessage' | translate }}</p>
      </div>

      <div *ngIf="rutControl" class="item-container">
        <opac-text-input formControlName="rut" [invalid]="rutControl | invalidControl">
          {{ 'signup.e0314.register.idLabel_run' | translate }}
          <span *ngIf="rutControl | invalidControl" slot="error">
            {{ 'signup.errors.e0314.invalidRut' | translate }}
          </span>
        </opac-text-input>
      </div>

      <!-- Terms and conditions checkbox -->
      <div *ngIf="termsControl" class="item-container">
        <opac-checkbox formControlName="terms" [invalid]="termsControl | invalidControl">
          {{ 'signup.terms' | translate }}
          <a [href]="termsUrl()" target="_blank" rel="noopener">
            {{ 'signup.termsUrl' | translate }}
          </a>

          <span *ngIf="termsControl | invalidControl" slot="error">
            {{ 'general.required.fieldLabel' | translate }}
          </span>
        </opac-checkbox>
      </div>

      <opac-button [disabled]="formGroup.invalid" [actionType]="'submit'">{{ 'common.accept' | translate }}
      </opac-button>
    </form>
  </div>
</app-split-container>
